// BudgetContent Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import async from 'async'
import ReactSelect from 'react-select'
import classnames from 'classnames'
import EstimateBudgetPhase from '../estimate_budget_phase/estimate_budget_phase.jsx'
import BudgetDraglayer from '../budget_draglayer/budget_draglayer.jsx'
import EstimateBudgetIntro from '../estimate_budget_intro/estimate_budget_intro.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import currency from '../../../lib/currency.jsx'
import Acl from '../../../lib/acl.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import DroppableContainer from '../../../common/common/droppable_container/droppable_container.jsx'
import EstimateBudgetItem from '../estimate_budget_item/estimate_budget_item.jsx'
import { getVatRateSelectOptionsForAllCountries } from '../../../lib/vat_rates_select_options.js'
import Util from '../../../lib/util.jsx'
import calculate from '../../../lib/calculate.jsx'
import Button from '../../../theme/common/button/button.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import { PHASE_TYPES } from '../../../../shared/constants'
import { v4 as uuidv4 } from 'uuid'

class BudgetContent extends Component {
  static get propTypes () {
    return {
      budget: PropTypes.object,
      projectBudget: PropTypes.object,
      rateCards: PropTypes.array,
      contact: PropTypes.object,
      user: PropTypes.object,
      estimateRateCards: PropTypes.array,
      rateMarkup: PropTypes.number,
      rate: PropTypes.number,
      phaseList: PropTypes.array,
      activityList: PropTypes.array,
      processPhaseSelect: PropTypes.func,
      onSearchSupplier: PropTypes.func,
      estimateBudget: PropTypes.array,
      estimatePhaseList: PropTypes.array,
      estimateActivityList: PropTypes.array,
      introText: PropTypes.string,
      projectStartDate: PropTypes.any,
      projectEndDate: PropTypes.any,
      projectCloseDate: PropTypes.any,
      projectTitle: PropTypes.string,
      contactName: PropTypes.string,
      filterType: PropTypes.string,
      disabledEdit: PropTypes.bool,
      onItemCreate: PropTypes.func,
      onItemUpdate: PropTypes.func,
      onItemRemove: PropTypes.func,
      onPhaseRemove: PropTypes.func,
      onPhaseToggle: PropTypes.func,
      createNewActivity: PropTypes.func,
      onUpdateIntroText: PropTypes.func,
      onCreateItemSupplier: PropTypes.func,
      onDeleteItemSupplier: PropTypes.func,
      onChange: PropTypes.func,
      onCreatePurchaseOrder: PropTypes.func,
      onViewPurchaseOrder: PropTypes.func,
      onCreateContact: PropTypes.func,
      calculateSpentAmount: PropTypes.func,
      hasPageBreakTop: PropTypes.bool,
      onUpdateInfo: PropTypes.func,
      onCopyPhase: PropTypes.func,
      showDate: PropTypes.bool,
      reloadBudgetData: PropTypes.bool,
      estimate: PropTypes.object,
      teamCountry: PropTypes.string,
      vatRate: PropTypes.number,
      onUpdateEstimateTotal: PropTypes.func,
      onUpdateEstimateType: PropTypes.func,
      calculateMarkupPercentage: PropTypes.func,
      calculateSellingPrice: PropTypes.func,
      poDownloadBaseUrl: PropTypes.string,
      onAddExpense: PropTypes.func,
      onEditExpense: PropTypes.func,
      taxRateVatOptions: PropTypes.array,
      onCreateTaxRate: PropTypes.func,
      isQuickbookConnected: PropTypes.bool,
      quickbookItems: PropTypes.array,
      reloadQuickbookItems: PropTypes.func,
      onCreateEstimate: PropTypes.func,
      onCreateInvoice: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      budget: null,
      projectBudget: null,
      rateCards: [],
      contact: null,
      user: null,
      estimateRateCards: [],
      rateMarkup: 0,
      rate: 0,
      phaseList: [],
      activityList: [],
      processPhaseSelect: null,
      onSearchSupplier: null,
      estimateBudget: [],
      estimatePhaseList: [],
      estimateActivityList: [],
      introText: '',
      projectStartDate: null,
      projectEndDate: null,
      projectCloseDate: null,
      projectTitle: '',
      contactName: '',
      filterType: 'all',
      disabledEdit: false,
      onItemCreate: null,
      onItemUpdate: null,
      onItemRemove: null,
      onPhaseRemove: null,
      onPhaseToggle: null,
      createNewActivity: null,
      onUpdateIntroText: null,
      onCreateItemSupplier: null,
      onDeleteItemSupplier: null,
      onChange: null,
      onCreatePurchaseOrder: null,
      onViewPurchaseOrder: null,
      onCreateContact: null,
      calculateSpentAmount: null,
      hasPageBreakTop: false,
      onUpdateInfo: null,
      onCopyPhase: null,
      showDate: false,
      reloadBudgetData: false,
      estimate: null,
      teamCountry: '',
      vatRate: 0,
      onUpdateEstimateTotal: null,
      onUpdateEstimateType: null,
      calculateMarkupPercentage: null,
      calculateSellingPrice: null,
      poDownloadBaseUrl: '',
      onAddExpense: null,
      onEditExpense: null,
      taxRateVatOptions: [],
      onCreateTaxRate: null,
      isQuickbookConnected: false,
      quickbookItems: [],
      reloadQuickbookItems: null,
      onCreateEstimate: null,
      onCreateInvoice: null
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      dataDate: null,
      editable: false,
      curType: 'expense'
    }

    const { showRate, showTax, showActivity } = this._getTaxSetting(
      this.props.estimate,
      this.props.isQuickbookConnected
    )

    this.data = {
      budget: this.props.budget,
      introText: this.props.introText,
      phaseKeyword: '',
      activityKeyword: '',
      isItemDragging: false,
      hideDateRange: !Acl.isPlannerAllowed(),
      projectCloseDate: props.projectCloseDate,
      showDate: props.showDate ? props.showDate : false,
      estimate: this.props.estimate,
      vats:
        this.props.estimate && this.props.estimate.vats
          ? this.props.estimate.vats
          : null,
      showRate: showRate,
      showTax: showTax,
      showActivity: showActivity,
      type:
        this.props.estimate && this.props.estimate.type
          ? this.props.estimate.type
          : 'activity-rate-tax',
      types: this._getActivityTypes()
    }
    this._disableStatusUpdate = false
    this._references = {
      introText: React.createRef(),
      droppablePagebreakTop: React.createRef()
    }

    this._updateReferences(this.data.budget)
    this._onUpdateTotal()
  }

  _getTaxSetting (estimate, isQuickbookConnected) {
    let showTax = false
    let showRate = false
    let showActivity = false

    if (estimate) {
      if (isQuickbookConnected) {
        if (estimate.type === 'activity') {
          showActivity = true
        } else if (
          estimate.type === 'activity-rate' ||
          estimate.type === 'activity-rate-tax'
        ) {
          estimate.type = 'activity-rate'
          showRate = true
        }
      } else {
        if (estimate.type === 'activity-rate-tax') {
          showTax = true
        } else if (estimate.type === 'activity') {
          showActivity = true
        } else if (estimate.type === 'activity-rate') {
          showRate = true
        }
      }
    }

    return { showTax, showRate, showActivity }
  }

  componentDidMount () {
    if (!this.data.budget?.phases?.length) {
      this._onAddNewPhase()
    }
  }

  componentWillReceiveProps (nextProps) {
    if (
      this.props.reloadBudgetData &&
      !_.isEqual(this.data.budget, nextProps.budget)
    ) {
      this.data.budget = this.props.budget
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount () {
    if (this._isEditEnabled()) {
      let bAddItem = true
      if (this.data.budget?.phases.length) {
        const phase = this.data.budget.phases[0]
        if (phase?.groups?.length) {
          const group = phase.groups[0]
          if (group?.items?.length) {
            bAddItem = false
          }
        }
      }

      if (bAddItem) {
        this.onAddActivity('time-activity')
      }
    }
  }

  _getActivityTypes () {
    if (!this.props.isQuickbookConnected) {
      return [
        {
          label: IntlUtil.convertMessage(
            'project.viewBudget.titleActivityRate'
          ),
          value: 'activity-rate'
        },
        {
          label: IntlUtil.convertMessage(
            'project.viewBudget.titleActivityRateTax'
          ),
          value: 'activity-rate-tax'
        },
        {
          label: IntlUtil.convertMessage('project.viewBudget.titleName'),
          value: 'activity'
        }
      ]
    } else {
      return [
        {
          label: IntlUtil.convertMessage(
            'project.viewBudget.titleActivityRate'
          ),
          value: 'activity-rate'
        },
        {
          label: IntlUtil.convertMessage('project.viewBudget.titleName'),
          value: 'activity'
        }
      ]
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!_.isEqual(this.props.budget, nextProps.budget)) {
      if (
        !this._disableStatusUpdate &&
        this.data.budget?.phases?.length &&
        nextProps.budget?.phases?.length
      ) {
        nextProps.budget.phases.map(phase => {
          const phaseObj = _.find(this.data.budget.phases, phaseObj => {
            return phaseObj.id === phase.id
          })

          if (phaseObj) {
            phaseObj.status = phase.status
          }
        })
      }

      this._disableStatusUpdate = false
    }

    if (
      nextProps.projectCloseDate &&
      this.data.projectCloseDate !== nextProps.projectCloseDate
    ) {
      this.data.projectCloseDate = nextProps.projectCloseDate
      this.setState({ dataDate: new Date() })
    }

    if (nextProps.showDate && this.data.showDate !== nextProps.showDate) {
      this.data.showDate = nextProps.showDate
      this.setState({ dataDate: new Date() })
    }

    if (nextProps.estimate) {
      this.data.estimate = nextProps.estimate
    }
  }

  render () {
    const isEstimate = this._isTypeEsimate()

    return (
      <div className='budget-content'>
        <EstimateBudgetIntro
          ref={this._references.introText}
          introText={this.data.introText}
          active={!!this.data.introText}
          onUpdate={this._onUpdateIntroText.bind(this)}
          onDeleteActivity={this._onDeleteActivity.bind(this)}
        />
        {!isEstimate && this._renderToolbar()}
        {this._renderPhaseList()}
        <BudgetDraglayer
          isEstimate={isEstimate}
          budget={this.data.budget}
          showRate={this.data.showRate}
          showTax={this.data.showTax}
          isDragging={false}
        />
        {!isEstimate && this._renderToolbar()}
      </div>
    )
  }

  _renderToolbar () {
    return (
      <div className='budgettoolbar'>
        <div className='budgetactions'>
          <span className='label'>
            <IntlMessage ident='project.viewBudget.toolbarCreateEstimate' />
          </span>
          <Button
            type='default'
            title='project.viewBudget.toolbarEstimate'
            className='toolaction'
            canHover
            onClick={this.props.onCreateEstimate}
          />
          <Button
            type='default'
            title='project.viewBudget.toolbarInvoice'
            canHover
            className='toolaction'
            onClick={this.props.onCreateInvoice}
          />
        </div>
      </div>
    )
  }

  refreshBudget (budget, estimate) {
    this.data.budget = budget
    if (estimate) {
      this.data.vats = estimate.vats || []
      this.data.estimate.totalInc = estimate.totalInc || 0
    }

    this._updateReferences(this.data.budget)

    this.setState({ dataDate: new Date() })
  }

  refreshDataItems (budgetData, items) {
    if (this.data.budget?.phases?.length) {
      const existingItemIds = []
      this.data.budget.phases.forEach((phase, phaseIdx) => {
        const newPhase = budgetData.phases[phaseIdx]
        if (newPhase) {
          phase.spentAmount = newPhase.spentAmount
          phase.percentage = newPhase.percentage
          phase.overSpent = newPhase.overSpent
        }

        phase.groups.forEach(group => {
          group.items.forEach(item => {
            if (item.id) {
              existingItemIds.push(item.id)

              const newItem = _.find(items, obj => obj.id === item.id)
              if (newItem) {
                item.initialBudget = newItem.initialBudget
                item.lockInitialBudget = newItem.lockInitialBudget
                item.spentAmount = newItem.spentAmount
                item.percentage = newItem.percentage
                item.purchaseOrders = newItem.purchaseOrders || []
                item.bUsed = newItem.bUsed || false
                item.expenseCount = newItem.expenseCount || 0
                item.poCount = newItem.poCount || 0
              }
            }
          })
        })
      })

      budgetData.phases.forEach(phase => {
        phase.groups[0].items.forEach(item => {
          if (
            item.id &&
            _.findIndex(existingItemIds, itemId => itemId === item.id) < 0
          ) {
            const phase = this.data.budget.phases[item.phaseNo - 1]
            if (phase) {
              phase.groups[0].items.push(item)
            }
          }
        })
      })
    }

    this.setState({ dataDate: new Date() })
  }

  _isTypeEsimate () {
    return false
  }

  _onChange () {
    if (this.props.onChange) {
      this.props.onChange(this.data.budget, this.data.projectCloseDate)
    }
  }

  addPhase (params = {}) {
    this._onAddNewPhase(params)
  }

  _getItemPosition (itemDragId) {
    let currItemIdx = 0
    let itemIdx = 0
    this.data.budget.phases.map(phase => {
      phase.groups.map(group => {
        group.items.map(item => {
          if (item.dragId === itemDragId) {
            currItemIdx = itemIdx
          }

          itemIdx++
        })
      })
    })

    return currItemIdx
  }

  onAddActivity (type) {
    const budget = this.data.budget
    const phase = budget?.phases?.length
      ? budget.phases[budget.phases.length - 1]
      : null

    if (phase) {
      phase.editable = false

      if (phase.groups.length === 0) {
        phase.groups.push({
          id: 0,
          items: []
        })
      }

      const lastIndex = phase.groups.length - 1
      const group = phase.groups[lastIndex]

      const activity = this.props.createNewActivity(
        budget,
        type,
        phase,
        group.id
      )
      group.items.push(activity)

      if (type === 'subtotal') {
        phase.groups.push({
          id: lastIndex + 1,
          items: []
        })

        this._onUpdateTotal()
        this._onItemCreate(activity)
      }

      this._onSavePhase(phase)
    }
  }

  showIntroEditor (bEditable) {
    this._references.introText.current.handler.ref.current.show(bEditable)
  }

  /* Event handlers */
  _onAddNewPhase (params = { type: PHASE_TYPES.REGULAR }) {
    // Remove empty items of previous phases
    const phases = this.data.budget.phases
    if (phases?.length) {
      phases.map(phase => {
        if (phase.groups?.length) {
          phase.groups.map(group => {
            if (group.items?.length) {
              group.items.map(item => {
                this._onRemoveEmptyItem(phase, group, item)
              })
            }
          })
        }
      })
    }

    // Next phase duration should start from previous phase toDate only if project has end date
    let fromDate = null
    let toDate = null
    if (phases.length && this.props.projectEndDate) {
      const prevPhase = phases[phases.length - 1]
      // If previous phase end date not equal to project end date
      if (
        prevPhase &&
        prevPhase.toDate &&
        !DateUtil.isDateEqual(this.props.projectEndDate, prevPhase.toDate)
      ) {
        const fromTS = new Date(prevPhase.toDate).getTime()
        const toTS = new Date(this.props.projectEndDate).getTime()

        if (fromTS <= toTS) {
          fromDate = prevPhase.toDate
          toDate = this.props.projectEndDate
        }
      }
    }

    const phase = {
      id: phases.length,
      dragId: this.data.budget.lastPhaseId++,
      dragItemType: 'phase',
      title: '',
      bTitleCompleted: false,
      fromDate: fromDate,
      toDate: toDate,
      status: 'estimate',
      total: 0,
      percentage: 0,
      spentAmount: 0,
      overSpent: 0,
      editable: 'title',
      expanded: true,
      groups: [
        {
          id: 0,
          items: []
        }
      ],
      cloverleafID: uuidv4()
    }

    if (params.type) {
      phase.type = params.type
    }

    phases.push(phase)
    this._updateReferences(this.data.budget)
    this.setState({ dataDate: new Date() })
  }

  /* Phase events */
  _onCopyPhase (phase) {
    if (this.props.onCopyPhase) {
      // For new budget object only for total calcuation purpose
      const newBudgetData = _.cloneDeep(this.data.budget)
      const newPhaseData = _.cloneDeep(phase)
      newPhaseData.id = newBudgetData.phases.length
      newPhaseData.status = 'estimate'
      newPhaseData.cloverleafID = uuidv4()

      newPhaseData.groups.map(group => {
        if (group.items?.length) {
          group.items.map(item => {
            item.spentAmount = 0
            item.expenseCount = 0
            item.poCount = 0
          })
        }
      })

      newPhaseData.spentAmount = 0
      newBudgetData.phases.push(newPhaseData)

      this._recalculateBudgetTotal(newBudgetData)

      this.props.onCopyPhase(
        this.data.budget,
        newBudgetData,
        phase,
        newPhase => {
          if (newPhase) {
            this.data.budget.phases.push(newPhase)

            // Update total
            this.data.budget.total = newBudgetData.total
            this.data.budget.totalSpent = newBudgetData.totalSpent

            if (!this._isTypeEsimate()) {
              this.data.budget.totalSellingPrice =
                newBudgetData.totalSellingPrice
              this.data.budget.noActiveTimeActivities =
                newBudgetData.noActiveTimeActivities
            }

            this._recalculateDiscountPhase(this.data.budget)
            this._updateReferences(this.data.budget)
            this.setState({ dataDate: new Date() })
          }
        }
      )
    }
  }

  _onChangePhase (phase, phaseIdx) {
    this.data.budget.phases[phaseIdx] = phase

    this.setState({ dataDate: new Date() })
  }

  _onChangeType ({ value }) {
    this.data.type = value
    if (value === 'activity') {
      this.data.showActivity = true
      this.data.showRate = false
      this.data.showTax = false
    } else if (value === 'activity-rate') {
      this.data.showActivity = false
      this.data.showRate = true
      this.data.showTax = false
    } else if (value === 'activity-rate-tax') {
      this.data.showActivity = false
      this.data.showRate = false
      this.data.showTax = true
    }

    this.setState({ dataDate: new Date() })
    if (this.props.onUpdateEstimateType) {
      this.props.onUpdateEstimateType(value)
    }
  }

  _onSavePhase (phase, phaseIdx) {
    this.data.budget.phases[phaseIdx] = phase

    this._onChange()
    this.setState({ dataDate: new Date() })
  }

  _onRemovePhase (phase) {
    _.remove(
      this.data.budget.phases,
      (phaseObj, _phaseIdx) => phaseObj.id === phase.id
    )

    const removeData = {
      removeItems: [],
      updateItems: [],
      type: this._isTypeEsimate() ? 'estimate' : 'project'
    }

    // Remove items
    if (phase.groups?.length) {
      phase.groups.map(group => {
        if (group.items?.length) {
          group.items.map(item => {
            removeData.removeItems.push({ id: item.id })
          })
        }
      })
    }

    this.data.budget.phases.map((phase, phaseIdx) => {
      phase.id = phaseIdx
      phase.groups.map((group, groupIdx) => {
        group.items.map((item, itemIdx) => {
          item.phaseNo = phaseIdx + 1
          item.groupNo = groupIdx + 1
          item.orderNo = itemIdx + 1

          removeData.updateItems.push({
            id: item.id,
            data: {
              phaseNo: item.phaseNo,
              groupNo: item.groupNo,
              orderNo: item.orderNo
            }
          })
        })
      })
    })

    if (this.props.onPhaseRemove) {
      this.props.onPhaseRemove(phase.id, removeData, () => {
        this._recalculateDiscountPhase(this.data.budget)
        this._onUpdateTotal()
      })
    }

    this.setState({ dataDate: new Date() })
  }

  _onRemoveEmptyItem (phase, curGroup, _activity) {
    _.remove(
      curGroup.items,
      item => item.title === '' && item.type !== 'subtotal'
    )

    if (curGroup.items.length === 0) {
      _.remove(phase.groups, group => group.id === curGroup.id)
    }
  }

  _onItemCreate (item) {
    if (this.props.onItemCreate) {
      this.props.onItemCreate(item)
      this._onUpdateItemReorder()
    }
  }

  _onItemUpdate (item, attribute) {
    if (!this.props.onItemUpdate) {
      return this._recalculateBudgetTotal(this.data.budget)
    }

    this.props.onItemUpdate(item, attribute, () => {
      this._recalculateDiscountPhase(this.data.budget)
      this._recalculateBudgetTotal(this.data.budget)
    })
  }

  _onItemRemove (item) {
    if (this.props.onItemRemove) {
      this.props.onItemRemove(item, () => {
        this._recalculateDiscountPhase(this.data.budget)
      })
    }
  }

  _onChangePhaseStatus (projectCloseDate) {
    this._onUpdateTotal()

    if (projectCloseDate) {
      this.data.projectCloseDate = projectCloseDate
      this._onChange()
    }
  }

  _onUpdateTotal () {
    this._recalculateBudgetTotal(this.data.budget)
    this._onChange()
  }

  _filterDiscountPhases (phases = []) {
    return phases.filter(phase => phase.type !== PHASE_TYPES.DISCOUNT) || []
  }

  _getDiscountPhase (phases = []) {
    return phases.find(phase => phase.type === PHASE_TYPES.DISCOUNT)
  }

  _recalculateDiscountPhase (budget) {
    if (!this.props.onItemUpdate) {
      return
    }

    const discountPhase = this._getDiscountPhase(budget.phases)

    if (!discountPhase?.groups?.length) {
      return
    }

    const subtotalWithoutDiscount = this._filterDiscountPhases(budget.phases)
      .reduce((prevValue, currValue) => prevValue + currValue.total, 0)

    discountPhase.total = discountPhase.groups[0].items
      .map(item => this._recalculateDiscountItem(item, subtotalWithoutDiscount))
      .reduce((prevValue, currValue) => prevValue + currValue, 0)
  }

  _recalculateDiscountItem (item, subtotal) {
    if (!this.props.onItemUpdate) {
      return
    }

    item.total = (item.discountPercentage * parseFloat(subtotal)) / 100 || 0

    this.props.onItemUpdate(item, ['total', 'discountPercentage'])

    return item.total
  }

  _recalculateBudgetTotal (budget) {
    const estimate = this.data.estimate
    let budgetTotal = 0
    let budgetTotalInc = 0
    let budgetTotalSpent = 0
    let budgetTotalSelling = 0
    let noActiveTimeActivities = 0
    const allItems = []

    budget.phases.map(phase => {
      phase.total = 0
      phase.spentAmount = 0
      phase.overSpent = 0

      let groupTotal = 0
      let groupSpentAmount = 0
      phase.groups.map(group => {
        groupTotal = _.sumBy(group.items, item =>
          item.type === 'subtotal' ? 0 : parseFloat(item.total || 0)
        )

        group.items.map(item => {
          allItems.push(item)

          let expenseTotal = 0
          let poTotal = 0

          if (item.type === 'subtotal') {
            item.total = groupTotal
          } else if (item.type === 'expense-activity') {
            budgetTotalSelling += item.sellingPrice
              ? parseFloat(item.sellingPrice)
              : 0
          } else if (item.type === 'time-activity') {
            budgetTotalSelling += parseFloat(item.total || 0)
          }

          if (item.spentAmount) {
            budgetTotalSpent += item.spentAmount
            groupSpentAmount += item.spentAmount
          }

          if (item.purchaseOrders?.length) {
            item.purchaseOrders.map(ord => {
              expenseTotal += ord.expenseTotal
              poTotal += ord.poTotal
            })
          }

          item.overSpent = 0
          if (poTotal > item.total) {
            item.overSpent = poTotal - item.total
          } else if (item.spentAmount > item.total) {
            item.overSpent = item.spentAmount - item.total
          } else if (expenseTotal > poTotal) {
            item.overSpent = expenseTotal - poTotal
          }

          phase.overSpent += item.overSpent

          // If phase is active, update the activity count
          if (phase.status === 'active') {
            if (item.type === 'time-activity') {
              noActiveTimeActivities++
            }
          }
        })

        phase.total += groupTotal
        phase.spentAmount += groupSpentAmount
        phase.percentage =
          phase.total > 0
            ? parseInt(Math.round((phase.spentAmount / phase.total) * 100))
            : 0
      })

      budgetTotal += phase.total
    })

    const vatInfo = calculate.calculateVatFromItems(allItems)

    budgetTotal = vatInfo.total
    budgetTotalInc = vatInfo.totalInc

    this.data.vats = []
    if (this._isTypeEsimate()) {
      estimate.totalExcl = budgetTotal
      estimate.totalInc = budgetTotalInc

      this.data.vats = vatInfo.vats || []
    }

    budget.total = parseFloat(budgetTotal.toFixed(2))
    budget.totalSpent = parseFloat(budgetTotalSpent.toFixed(2))

    if (!this._isTypeEsimate()) {
      budget.totalSellingPrice = parseFloat(budgetTotalSelling).toFixed(2)
      budget.noActiveTimeActivities = noActiveTimeActivities
    }

    if (this.props.onUpdateEstimateTotal) {
      this.props.onUpdateEstimateTotal(budgetTotal, budgetTotalInc)
    }
  }

  _getVatAmount (amount, vat) {
    if (vat && parseFloat(vat) > 0 && amount !== 0) {
      const vatAmount = (parseFloat(amount) * parseFloat(vat)) / 100
      return currency.round(vatAmount)
    }

    return 0
  }

  _reArrangeSubtotal () {
    this.data.budget.phases.map(phase => {
      const newGroups = []
      let nextGroupId = 0
      let newGroup = { id: nextGroupId++, items: [] }
      newGroups.push(newGroup)

      phase.groups.map(group => {
        group.items.map((item, _itemIdx) => {
          item.groupId = newGroup.id
          newGroup.items.push(item)

          if (item.type === 'subtotal') {
            newGroup = { id: nextGroupId++, items: [] }
            newGroups.push(newGroup)
          }
        })
      })

      phase.groups = newGroups
    })
  }

  /* Activity Drag and drop events */
  _getPhaseIndex (dragId) {
    return _.findIndex(
      this.data.budget.phases,
      phase => phase.dragId === dragId
    )
  }

  _onMovePhase (phase, currIndex, overIndex) {
    if (overIndex !== currIndex) {
      this.data.budget.phases.splice(currIndex, 1)
      this.data.budget.phases.splice(overIndex, 0, phase)

      this.data.budget.phases.map((phase, phaseIdx) => {
        phase.id = phaseIdx
      })

      this.setState({ dataDate: new Date() })
    }
  }

  _onSavePhaseDrop () {
    // Update the phase total and budget total
    this._disableStatusUpdate = true
    this._onUpdateTotal()
    this._onUpdateItemReorder()
  }

  _onDropPhaseItem () {
    // Save budget
    this.data.isItemDragging = false
    this._removeEmptyDragItems()

    // If subtotal is dropped in some other group, split the group
    this._reArrangeSubtotal()

    // Update the phase total and budget total
    this._onUpdateTotal()
    this._onUpdateItemReorder()
  }

  _onDeleteSubtotal () {
    // If subtotal is deleted, merge the groups
    this._reArrangeSubtotal()

    // Update the phase total and budget total
    this._onUpdateTotal()
  }

  _onUpdateItemReorder () {
    const allItems = []
    this.data.budget.phases.map((phase, phaseIdx) => {
      phase.groups.map((group, groupIdx) => {
        group.items.map((item, itemIdx) => {
          item.phaseId = phase.id
          item.groupId = group.id
          item.phaseNo = phaseIdx + 1
          item.groupNo = groupIdx + 1
          item.orderNo = itemIdx + 1

          if (!this._isTypeEsimate()) {
            item.isActive = phase.status === 'active'
          }

          allItems.push(item)
        })
      })
    })

    async.map(
      allItems,
      (item, mapDone) => {
        this.props.onItemUpdate(
          item,
          ['phaseNo', 'groupNo', 'orderNo', 'isActive'],
          updateErr => {
            mapDone(updateErr)
          }
        )
      },
      err => {
        if (err) {
          // Update total after reordering items
          this._onUpdateTotal()
        }
      }
    )
  }

  _onMoveItem (
    oldPhaseId,
    oldGroupId,
    newPhaseId,
    newGroupId,
    overItemId,
    item,
    originalIndex
  ) {
    const oldPhaseObj = _.find(
      this.data.budget.phases,
      obj => obj.id === oldPhaseId
    )
    let oldGroupObj = null

    if (oldPhaseObj) {
      oldGroupObj = _.find(oldPhaseObj.groups, obj => obj.id === oldGroupId)
    }

    if (!oldGroupObj) {
      return
    }

    const bPageBreak = item.type === 'pagebreak'

    if (oldPhaseId === newPhaseId && oldGroupId === newGroupId) {
      // Find index
      const items = oldGroupObj.items
      const currItemIndex = _.findIndex(
        items,
        obj => obj.dragId === item.dragId
      )
      let overItemIndex = originalIndex

      if (overItemId) {
        overItemIndex = _.findIndex(items, obj => obj.dragId === overItemId)
      }

      // If item is pagebreak
      // If new position is first of phase, or last of phase then dont allow to move item
      const lastItemIdx = items.length - 1
      if (
        bPageBreak &&
        (overItemIndex === 0 || overItemIndex === lastItemIdx)
      ) {
        return
      }

      if (overItemIndex !== currItemIndex) {
        items.splice(currItemIndex, 1)
        items.splice(overItemIndex, 0, item)
      }
    } else {
      const newPhaseObj = _.find(
        this.data.budget.phases,
        obj => obj.id === newPhaseId
      )

      if (newPhaseObj) {
        if (newPhaseObj.type === 'discount') {
          return
        }

        const newGroupObj = _.find(
          newPhaseObj.groups,
          obj => obj.id === newGroupId
        )
        if (newGroupObj) {
          // Find index
          let overItemIndex = originalIndex
          if (overItemId) {
            overItemIndex = _.findIndex(
              newGroupObj.items,
              obj => obj.dragId === overItemId
            )
          }

          // If item is pagebreak, and If new position is first of phase, dont allow to move item
          // But new position can be last index, since it is new group
          if (bPageBreak && overItemIndex === 0) {
            return
          }

          item.phaseId = newPhaseId
          item.groupId = newGroupId

          _.remove(oldGroupObj.items, obj => obj.dragId === item.dragId)

          if (overItemIndex >= 0) {
            newGroupObj.items.splice(overItemIndex, 0, item)
          }
        }
      }
    }

    this.setState({ dataDate: new Date() })
  }

  _onDragStart (activity) {
    this.data.isItemDragging = true
    this.setState({ dataDate: new Date() })

    if (
      activity?.type === 'text' &&
      this._references.introText?.current?.handler?.ref?.current
    ) {
      window.setTimeout(() => {
        this._references.introText.current.handler.ref.current.show(false)
      }, 100)
    }

    if (activity && activity.type === 'pagebreak') {
      window.setTimeout(() => {
        if (this._references.droppablePagebreakTop?.current?.handler) {
          this._references.droppablePagebreakTop.current.handler.ref.current.show()
        }

        if (this.data.budget && this.data.budget.phases) {
          this.data.budget.phases.map((_phase, phaseIdx) => {
            const phaseRef = this._references[
              `droppablePagebreakPhase-${phaseIdx}`
            ]
            if (phaseRef && phaseRef.current) {
              phaseRef.current.handler.ref.current.show()
            }
          })
        }
      }, 100)
    }
  }

  _onDragEnd () {
    this.data.isItemDragging = false
    this._removeEmptyDragItems()
    this.setState({ dataDate: new Date() })

    if (
      !this.data.introText &&
      this._references.introText?.current?.handler?.ref?.current
    ) {
      this._references.introText.current.handler.ref.current.hide()
    }

    if (this._references.droppablePagebreakTop?.current?.handler) {
      this._references.droppablePagebreakTop.current.handler.ref.current.hide()
    }

    if (this.data.budget && this.data.budget.phases) {
      this.data.budget.phases.map((_phase, phaseIdx) => {
        const phaseRef = this._references[`droppablePagebreakPhase-${phaseIdx}`]
        if (phaseRef && phaseRef.current) {
          phaseRef.current.handler.ref.current.hide()
        }
      })
    }
  }

  _removeEmptyDragItems () {
    this.data.budget.phases.map(phase => {
      phase.groups.map(group => {
        _.remove(group.items, obj => obj.isEmptyDragItem)
      })
    })
  }

  _onUpdateIntroText (introText, callback) {
    this.data.introText = introText
    this.setState({ dataDate: new Date() })

    if (this.props.onUpdateIntroText) {
      this.props.onUpdateIntroText(introText, callback)
    }
  }

  _onDeleteActivity (activity) {
    this._removeActivityFromGroup(activity)
    this.setState({ dataDate: new Date() })
  }

  _onDropPagebreakTop (activity) {
    this._removeActivityFromGroup(activity)
    if (this.props.onUpdateInfo) {
      this.props.onUpdateInfo({ hasPageBreakTop: true }, () => {
        this.setState({ dataDate: new Date() })
      })
    }
  }

  _onDropPagebreakPhase (phaseIdx, activity) {
    this._removeActivityFromGroup(activity)
    if (this.props.onUpdateInfo) {
      this.data.budget.phases[phaseIdx].hasPageBreakTop = true
      this.props.onUpdateInfo({ budget: this.data.budget }, () => {
        this.setState({ dataDate: new Date() })
      })
    }
  }

  _removeActivityFromGroup (activity) {
    const group = this.data.budget.phases[activity.phaseId].groups[
      activity.groupId
    ]
    _.remove(group.items, obj => obj.id === activity.id)

    this._onItemRemove(activity)
  }

  _onRemovePagebreakTop () {
    if (this.props.onUpdateInfo) {
      this.props.onUpdateInfo({ hasPageBreakTop: false }, () => {
        this.setState({ dataDate: new Date() })
      })
    }
  }

  _onRemovePagebreakPhase (phaseIdx) {
    if (this.props.onUpdateInfo) {
      this.data.budget.phases[phaseIdx].hasPageBreakTop = false
      this.props.onUpdateInfo({ budget: this.data.budget }, () => {
        this.setState({ dataDate: new Date() })
      })
    }
  }

  _onShowDateType () {
    this.data.showDate = !this.data.showDate
    this.setState({ dataDate: new Date() })
  }

  /* Private Functions */
  _renderPhaseList () {
    const budgetWrapCls = this._isTypeEsimate() ? 'budgetcontentwrap estimate' : 'budgetcontentwrap'
    const _bdgtphasesClass = classnames('bdgtphases', {
      bdgtphases_single: this.data?.budget?.phases?.length === 1 && this.data.budget.phases[0].title !== ''
    })

    return (
      <div className={budgetWrapCls}>
        {this._isTypeEsimate() &&
          (this.props.hasPageBreakTop ? (
            <EstimateBudgetItem
              isEstimate
              disableDrag
              item={{ type: 'pagebreak' }}
              onRemove={this._onRemovePagebreakTop.bind(this)}
            />
          ) : (
            <DroppableContainer
              ref={this._references.droppablePagebreakTop}
              title='project.viewBudget.dropPagebreakMessage'
              onDropItem={this._onDropPagebreakTop.bind(this)}
            />
          ))}
        {this._renderContentHeader()}
        <div className={_bdgtphasesClass}>{this._renderPhases()}</div>
        {this._renderFooter()}
      </div>
    )
  }

  _renderContentHeader () {
    if (this._isTypeEsimate()) {
      let className = 'bdgtheader estimate'
      if (this.data.showRate) {
        className = 'bdgtheader estimate rate'
      } else if (this.data.showTax) {
        className = 'bdgtheader estimate tax'
      } else {
        className = 'bdgtheader estimate activity'
      }

      const foundType = _.find(
        this.data.types,
        obj => obj.value === this.data.type
      )

      return (
        <div className={className}>
          <div className='bdgtheadercol coltitle'>
            <ReactSelect
              name='type'
              className='select-alt'
              value={foundType || null}
              options={this.data.types}
              clearable={false}
              openOnFocus
              onChange={this._onChangeType.bind(this)}
              classNamePrefix='iteminner'
            />
          </div>
          <div className='bdgtheadercol colprogress'>
            <IntlMessage ident='project.viewBudget.titleHours' />
          </div>
          <div className='bdgtheadercol colbudget'>
            <IntlMessage ident='project.viewBudget.titleRate' />
          </div>
          <div className='bdgtheadercol colvat'>
            <IntlMessage ident='project.viewBudget.titleVAT' />
          </div>
          <div className='bdgtheadercol colspent'>
            <IntlMessage ident='project.viewBudget.titlePrice' />
          </div>
        </div>
      )
    }

    const titleCls = Acl.isPlannerAllowed()
      ? 'bdgtheadercol coltitle showdate'
      : 'bdgtheadercol coltitle'
    return (
      <div className='horizontal-padding-wrap'>
        <div className='bdgtheader project'>
          <div
            className={titleCls}
            onClick={
              Acl.isPlannerAllowed() ? this._onShowDateType.bind(this) : null
            }
          >
            <span className='titlelabel'>
              {this.data.showDate ? (
                <IntlMessage ident='project.viewBudget.headerDateTitle' />
              ) : (
                <IntlMessage ident='project.viewBudget.headerTitle' />
              )}
              {Acl.isPlannerAllowed() && (
                <span className='itemaccordion'>
                  <i className='icon icon-grid-expand normal' />
                </span>
              )}
            </span>
          </div>
          <div className='bdgtheadercol colhours'>
            <IntlMessage ident='project.viewBudget.headerHoursTitle' />
          </div>
          <div className='bdgtheadercol colrate'>
            <IntlMessage ident='project.viewBudget.headerRateTitle' />
          </div>
          <div className='bdgtheadercol colbudget'>
            <IntlMessage ident='project.viewBudget.headerBudget' />
          </div>
          <div className='bdgtheadercol colsellingprice'>
            <IntlMessage ident='project.viewBudget.headerSellingPrice' />
          </div>
          <div className='bdgtheadercol colspent'>
            <IntlMessage ident='project.viewBudget.headerSpend' />
          </div>
          <div className='bdgtheadercol colinvoiced'>
            <IntlMessage ident='project.viewBudget.headerInvoiced' />
            <IconButton
              icon='list-iteminfo'
              size='normal'
              canHover={false}
              className='invoiceinfo'
              tooltip='project.viewBudget.headerInvoicedDescription'
              tooltipPosition='bottom'
            />
          </div>
        </div>
      </div>
    )
  }

  _renderPhases () {
    if (!this.data?.budget?.phases.length) {
      return null
    }

    return this._filterDiscountPhases(this.data.budget.phases)
      .map((phase, idx) => {
        return (
          <div className='phasewrap' key={idx}>
            {this._isTypeEsimate() &&
              (phase.hasPageBreakTop ? (
                <EstimateBudgetItem
                  isEstimate
                  disableDrag
                  item={{ type: 'pagebreak' }}
                  onRemove={this._onRemovePagebreakPhase.bind(this, idx)}
                />
              ) : (
                <DroppableContainer
                  ref={this._references[`droppablePagebreakPhase-${idx}`]}
                  title='project.viewBudget.dropPagebreakMessage'
                  onDropItem={this._onDropPagebreakPhase.bind(this, idx)}
                />
              ))}
            {this._renderPhase(phase, idx)}
          </div>
        )
      })
  }

  _renderDiscountPhase () {
    if (!this.data?.budget?.phases.length) {
      return null
    }

    const discountPhase = this._getDiscountPhase(this.data.budget.phases)

    if (!discountPhase) {
      return null
    }

    return (
      <div className='phasewrap'>
        {this._renderPhase(discountPhase, 0, { isDiscountPhase: true })}
      </div>
    )
  }

  _renderPhase (phase, idx, params = { isDiscountPhase: false }) {
    const { budget, isItemDragging, hideDateRange, estimate } = this.data
    const address = estimate?.contactAddress ? estimate.contactAddress : null

    // TODO: This part is also related to VATs but for estimate. We should fix it like what we did in SUP-1414 for invoices.
    // Form vat options based on current team and current estimate country and Show default vat 0% based on two conditions
    let vatLevels = getVatRateSelectOptionsForAllCountries().NL
    let showDefaultVat = false

    if (this.props.teamCountry === 'US') {
      if (!address || !address.state) {
        showDefaultVat = true
      }
    } else if (this.props.teamCountry && address && address.country) {
      let estimateCountry = address.country
      if (estimateCountry === 'GB') {
        estimateCountry = 'UK'
      }

      if (this.props.teamCountry === 'UK' && estimateCountry === 'UK') {
        vatLevels = getVatRateSelectOptionsForAllCountries().UK
      } else if (this.props.teamCountry === 'DE' && estimateCountry === 'DE') {
        vatLevels = getVatRateSelectOptionsForAllCountries().DE
      } else if (this.props.teamCountry === 'US' && estimateCountry === 'US') {
        vatLevels = getVatRateSelectOptionsForAllCountries().US
      }

      if (!Util.isEuropeCountry(estimateCountry)) {
        showDefaultVat = true
      } else if (
        this.props.teamCountry !== estimateCountry &&
        Util.isEuropeCountry(estimateCountry)
      ) {
        showDefaultVat = true
      }
    }

    return (
      <EstimateBudgetPhase
        key={idx}
        isEstimate={this._isTypeEsimate()}
        phase={phase}
        index={idx}
        budget={budget}
        projectBudget={this.props.projectBudget}
        rateCards={this.props.rateCards}
        estimateRateCards={this.props.estimateRateCards}
        rateMarkup={this.props.rateMarkup}
        rate={this.props.rate}
        phaseList={this.props.phaseList}
        activityList={this.props.activityList}
        estimateBudget={this.props.estimateBudget}
        estimatePhaseList={this.props.estimatePhaseList}
        estimateActivityList={this.props.estimateActivityList}
        isItemDragging={isItemDragging}
        hideDateRange={hideDateRange}
        filterType={this.props.filterType}
        disabledEdit={!this._isEditEnabled()}
        showDate={!hideDateRange && this.data.showDate}
        isQuickbookConnected={this.props.isQuickbookConnected}
        quickbookItems={this.props.quickbookItems}
        onChange={this._onChangePhase.bind(this, idx)}
        onSave={this._onSavePhase.bind(this, idx)}
        onRemove={this._onRemovePhase.bind(this)}
        onUpdateTotal={this._onUpdateTotal.bind(this)}
        onDropItem={this._onDropPhaseItem.bind(this)}
        onMoveItem={this._onMoveItem.bind(this)}
        onItemCreate={this._onItemCreate.bind(this)}
        onItemUpdate={this._onItemUpdate.bind(this)}
        onItemRemove={this._onItemRemove.bind(this)}
        onDragStart={this._onDragStart.bind(this)}
        onDragEnd={this._onDragEnd.bind(this)}
        processPhaseSelect={this.props.processPhaseSelect}
        onSearchSupplier={this.props.onSearchSupplier}
        onDeleteSubtotal={this._onDeleteSubtotal.bind(this)}
        onCreateItemSupplier={this.props.onCreateItemSupplier}
        onDeleteItemSupplier={this.props.onDeleteItemSupplier}
        onCreatePurchaseOrder={this.props.onCreatePurchaseOrder}
        onChangePhaseStatus={this._onChangePhaseStatus.bind(this)}
        onViewPurchaseOrder={this.props.onViewPurchaseOrder}
        onCreateContact={this.props.onCreateContact}
        onPhaseToggle={this._onPhaseToggle.bind(this)}
        calculateSpentAmount={this.props.calculateSpentAmount}
        projectCloseDate={this.data.projectCloseDate}
        projectStartDate={this.props.projectStartDate}
        projectEndDate={this.props.projectEndDate}
        projectTitle={this.props.projectTitle}
        contactName={this.props.contactName}
        onCopy={this._onCopyPhase.bind(this)}
        getPhaseIndex={this._getPhaseIndex.bind(this)}
        onMovePhase={this._onMovePhase.bind(this)}
        onSavePhaseDrop={this._onSavePhaseDrop.bind(this)}
        onUpdateItemReorder={this._onUpdateItemReorder.bind(this)}
        getItemPosition={this._getItemPosition.bind(this)}
        showDefaultVat={showDefaultVat}
        vatLevels={vatLevels}
        vatRate={showDefaultVat ? 0 : this.props.vatRate}
        showActivity={this.data.showActivity}
        showRate={this.data.showRate}
        showTax={this.data.showTax}
        taxRateVatOptions={this.props.taxRateVatOptions}
        showVatAutocomplete={this.props.teamCountry === 'US'}
        showLabelType={this.props.teamCountry === 'US'}
        calculateMarkupPercentage={this.props.calculateMarkupPercentage}
        calculateSellingPrice={this.props.calculateSellingPrice}
        poDownloadBaseUrl={this.props.poDownloadBaseUrl}
        onAddExpense={this.props.onAddExpense}
        onEditExpense={this.props.onEditExpense}
        onCreateTaxRate={this.props.onCreateTaxRate}
        reloadQuickbookItems={this.props.reloadQuickbookItems}
        isDiscountPhase={params.isDiscountPhase}
      />
    )
  }

  _onPhaseToggle () {
    if (this.props.onPhaseToggle) {
      this.props.onPhaseToggle(this.data.budget)
    }
  }

  _renderAddPhase () {
    const _class = this.state.editable ? 'bdgtaddphase form' : 'bdgtaddphase'
    return (
      <div
        className={_class}
        title={IntlUtil.convertMessage('project.viewBudget.titleNewPhase')}
      >
        <div className='addaction' onClick={() => this._onAddNewPhase()}>
          <span className='iconcont'>
            <i className='icon icon-budget-add-phase' />
          </span>
          <span className='title'>
            <IntlMessage ident='project.viewBudget.titleNewPhase' />
          </span>
        </div>
      </div>
    )
  }

  _renderFooter () {
    const { showTax } = this.data
    const [hasVat] = this.data?.vats || []
    const discountPhase = this._getDiscountPhase(this.data?.budget?.phases)
    const headerClassName = classnames('bdgtheader', 'discount', {
      showtax: showTax
    })

    if (!discountPhase) {
      return (
        <div className='budfoot'>
          {this._isEditEnabled() && this._renderAddPhase()}
          <div className='viewtotalfooter'>
            <div className='viewtotalcol'>
              {showTax && this._renderSubtotal()}
              {showTax && this._renderVat()}
              {this._renderTotal({ showTax: showTax && hasVat })}
            </div>
          </div>
        </div>
      )
    }

    return (
      <div>
        <div className='budfoot'>
          {this._isEditEnabled() && this._renderAddPhase()}
          <div className='viewtotalfooter'>
            <div className='viewtotalcol'>
              {this._renderSubtotal({ subtractValue: discountPhase.total })}
            </div>
          </div>
        </div>

        <div className={headerClassName}>
          <div className='bdgtheadercol coldiscountfee'>
            <IntlMessage ident='project.viewBudget.titleDiscountFee' />
          </div>
          <div className='bdgtheadercol colvat'>
            <IntlMessage ident='project.viewBudget.titleVAT' />
          </div>
          <div className='bdgtheadercol colspent'>
            <IntlMessage ident='project.viewBudget.titlePrice' />
          </div>
        </div>

        <div className='bdgtphases discounts'>
          {this._renderDiscountPhase()}
        </div>

        <div className='budfoot'>
          <div className='bdgtaddphase' />
          <div className='viewtotalfooter'>
            <div className='viewtotalcol'>
              {this._renderDiscountFee(discountPhase)}
              {showTax && this._renderVat()}
              {this._renderTotal({ showTax: showTax && hasVat })}
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderSubtotal (params = { subtractValue: 0 }) {
    const { estimate } = this.data

    if (!this._isTypeEsimate() || !estimate) {
      return null
    }

    return (
      <div className='viewsubtotal'>
        <span className='label'>
          <IntlMessage ident='estimate.view.titleSubTotal' />
        </span>
        <div className='viewcol colprice'>
          <h2 className='moneyvalue'>
            <span className='prefix'>{currency.symbol()}</span>
            <span className='value'>
              {currency.format(estimate.totalExcl - params.subtractValue)}
            </span>
          </h2>
        </div>
      </div>
    )
  }

  _renderTotal ({ showTax = false }) {
    const { estimate } = this.data

    if (!this._isTypeEsimate() || !estimate) {
      return null
    }

    return (
      <div className='viewtotal'>
        <span className='label'>
          {showTax ? (
            <IntlMessage ident='estimate.view.titleTotalIncl' />
          ) : (
            <IntlMessage ident='estimate.view.titleTotalExcl' />
          )}
        </span>
        <div className='viewcol colprice'>
          <h2 className='moneyvalue'>
            <span className='prefix'>{currency.symbol()}</span>
            <span className='value'>
              {showTax ? (
                currency.format(estimate.totalInc)
              ) : (
                currency.format(estimate.totalExcl)
              )}
            </span>
          </h2>
        </div>
      </div>
    )
  }

  _isEditEnabled () {
    return !this.props.disabledEdit
  }

  _renderVat () {
    if (!this.data?.vats?.length) {
      return null
    }

    return this.data.vats.map((vatObj, idx) => {
      return (
        <div className='viewvat' key={idx}>
          <span className='label'>
            <IntlMessage ident='estimate.view.titleVAT' /> {vatObj.vat}%
          </span>
          <div className='viewcol colprice'>
            <h2 className='moneyvalue'>
              <span className='prefix'>{currency.symbol()}</span>
              <span className='value'>
                {this._getAmountValue(vatObj.amount)}
              </span>
            </h2>
          </div>
        </div>
      )
    })
  }

  _renderDiscountFee (discountPhase) {
    return (
      <div className='viewsubtotal'>
        <span className='label'>
          {discountPhase.total >= 0
            ? (<IntlMessage ident='estimate.view.fee' />)
            : (<IntlMessage ident='estimate.view.discount' />)}
        </span>
        <div className='viewcol colprice'>
          <h2 className='moneyvalue'>
            <span className='prefix'>{currency.symbol()}</span>
            <span className='value'>
              {this._getAmountValue(discountPhase.total)}
            </span>
          </h2>
        </div>
      </div>
    )
  }

  _getAmountValue (amount) {
    return currency.format(amount)
  }

  _updateReferences (budget) {
    if (budget && budget.phases) {
      budget.phases.forEach(phase => {
        if (!this._references[`droppablePagebreakPhase-${phase.id}`]) {
          this._references[
            `droppablePagebreakPhase-${phase.id}`
          ] = React.createRef()
        }
      })
    }
  }
}

export default BudgetContent
